import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PbxServerSchema } from "../../Schemas/PbxServer";
import { PbxTrunkSchema } from "../../Schemas/PbxTrunk";

export interface PbxServerResponseBody extends IResponseBody {
  data: {
    pbx_trunk: PbxTrunkSchema;
  };
}

export class PbxTrunkDeleteRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(id: number) {
    return `/admin/pbx-trunks/${id}/delete`;
  }

  async send(serverId: number): Promise<PbxServerResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(serverId),
        {}
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
